module.exports = __webpack_public_path__ + "assets/img/u89.7009950b.png";